'use client';
import React, { Component } from 'react';
import './style.sass';
import '../reusable-components/style.sass';

import Team from '../reusable-components/layouts-components__letovo/team';
import Tasks from '../reusable-components/layouts-components__letovo/tasks';
import MainTitle from '../reusable-components/layouts-components__common-cases/main-title';
import Complex from '../reusable-components/layouts-components__letovo/complex';
import Process from '../reusable-components/layouts-components__letovo/process';
import PortfolioGallery from '../reusable-components/layouts-components__letovo/portfolio-gallery';
import Digits from '../reusable-components/layouts-components__letovo/digits';
import Results from '../reusable-components/layouts-components__letovo/results';
import Review from '../reusable-components/layouts-components__common-cases/review';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import CommonSmallText from '../common-components/common-small-text';
import CommonSmallTitle from '../common-components/common-small-title';
import OfferButton from '../../../../../shared/sections/OfferButton';

const letovoMainTitle = {
    titleMainText: `Модернизация и&nbsp;многочисленные интеграции сайта школы &laquo;Летово&raquo;: лиды из&nbsp;черновиков и&nbsp;более удобный&nbsp;ЛК`,
    titleAnimation: '/images/pic/preview/letovo.png',
    subtitleContainer: [
        {
            modeText: 'клиент',
            colorMode: '#0cc0dd',
            nameText: 'Международная школа для одаренных детей &laquo;Летово&raquo;',
        },
        {
            modeText: 'Отрасль',
            colorMode: '#0cc0dd',
            nameText: 'Образование',
        },
        {
            modeText: 'Услуги',
            colorMode: '#0cc0dd',
            nameText:
                'Редизайн сайта, интеграции, модернизация личного кабинета, техническая и&nbsp;информационная поддержка',
        },
        {
            modeText: 'Технологии',
            colorMode: '#0cc0dd',
            nameText: 'React, Webpack, Sass, Bitrix, PHP, Laravel',
        },
    ],
};

const reviewLetovo = {
    reviewText: `<p>С&nbsp;2017 года команда &laquo;Вебпрактик&raquo; изменяет наш сайт под возникающие потребности: внедряет полезные интеграции маркетинговых и&nbsp;других сервисов, предлагает доработки по&nbsp;структуре и&nbsp;личному кабинету,&nbsp;&mdash; и&nbsp;обеспечивает его круглосуточную доступность. Мы&nbsp;получаем всеобъемлющую техническую и&nbsp;информационную поддержку и&nbsp;видим, как вносимые изменения повышают юзабилити сайта и&nbsp;облегчают работу нашим сотрудникам.</p>
                                Сайт&nbsp;&mdash; наш основной инструмент для сбора заявок на&nbsp;обучение, и&nbsp;в&nbsp;результате совместной работы с&nbsp;командой &laquo;Вебпрактик&raquo; их&nbsp;количество стабильно растёт. Мы&nbsp;можем порекомендовать агентство как инициативного и&nbsp;вовлеченного партнера, который полностью погружается в&nbsp;задачи клиента.`,
    reviewAuthors: [
        {
            title: 'Алексей Красносельский',
            subtitle: 'директор по маркетингу школы Летово',
            img: '/images/pic/letovo/reviewimg.jpeg',
        },
    ],
    downLoadPresentationText: '&nbsp; Получить презентацию кейса',
};

const nextProjectLetovo = {
    nextProjectTitle: 'Провели комплексную работу по обновлению бренда Фонда ЖКХ',
    nextProjectImg: '/images/pic/preview/zkhfoundation.png',
    nextProjectLink: '/cases/development/zkhfoundation',
    nextProjectLinkTitle: 'ГК Фонд содействия реформированию ЖКХ',
    nextProjectText: 'Это государственный фонд, который отвечает за реформирование ЖКХ в России.',
};

class Letovo extends Component {
    render() {
        return (
            <section className="letovo">
                <MainTitle MainTitle={letovoMainTitle}>
                    <CommonSmallTitle className="letovo__subtitle">Школа «Летово»</CommonSmallTitle>
                    <CommonSmallText>
                        Это школа международного уровня для одаренных детей, где преподают учителя
                        из&nbsp;разных стран. Миссия школы&nbsp;&mdash; обеспечить всем способным
                        и&nbsp;мотивированным школьникам из&nbsp;любых уголков страны возможности
                        для получения качественного образования мирового уровня и&nbsp;раскрытия
                        их&nbsp;интеллектуального и&nbsp;творческого потенциала.
                    </CommonSmallText>
                </MainTitle>

                <Tasks />

                <Complex />

                <Process />

                <PortfolioGallery />

                <Results />

                <Digits />

                <Team />

                <Review Review={reviewLetovo} />

                <ScrollAnimation animateIn="zoomIn" offset={50} animateOnce={true} duration={1}>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>

                <NextProject NextProject={nextProjectLetovo} />
            </section>
        );
    }
}

export default Letovo;
